(function($) {

    function changeMapStyles(map) {
        var featureOpts = [
            {
                "featureType": "all",
                "elementType": "all",
                "stylers": [
                    { "saturation": -100 },
                    { "lightness": -25 }
                ]
            },
            {
                "featureType": "poi",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            }
        ];

        map.setOptions({
            styles: featureOpts
        });
    }

    function new_map($el) {

        var $markers = $el.find('.marker');
        var args = {
            zoom: 16,
            center: new google.maps.LatLng(0, 0),
            mapTypeId: google.maps.MapTypeId.ROAD,
            disableDefaultUI: true,
            scrollwheel: false
        };

        var map = new google.maps.Map($el[0], args);
        map.markers = [];
        if ($(window).width() <= '629') {
            map.panBy(0, -35.5)
        } else if ($(window).width() <= '700') {
            map.panBy(Math.floor($(window).width() / 3), 0)
        } else {
            map.panBy(Math.floor($(window).width() / 4), 0)
        }



        $markers.each(function() {

            add_marker($(this), map);

        });

        google.maps.event.addDomListener(window, "resize", function() {
            var center = map.getCenter();
            google.maps.event.trigger(map, "resize");
            map.setCenter(center);
        });

        center_map(map);
        return map;

    }



    function add_marker($marker, map) {

        var latlng = new google.maps.LatLng($marker.attr('data-lat'), $marker.attr('data-lng'));
        var marker = new google.maps.Marker({
            position: latlng,
            map: map,
            icon: $marker.attr('data-marker')
        });

        map.markers.push(marker);

        if ($marker.html()) {
            var infowindow = new google.maps.InfoWindow({
                content: $marker.html()
            });

            google.maps.event.addListener(marker, 'click', function() {
                infowindow.open(map, marker);
            });
        }
    }

    function center_map(map) {

        var bounds = new google.maps.LatLngBounds();

        $.each(map.markers, function(i, marker) {

            var latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());

            bounds.extend(latlng);

        });

        if (map.markers.length == 1) {
            map.setCenter(bounds.getCenter());
            map.setZoom(16);
        } else {
            map.fitBounds(bounds);
        }

    }

    var map = null;
    $(document).ready(function() {
        $('.acf-map').each(function() {
            map = new_map($(this));
            changeMapStyles(map);
        });
    });

})(jQuery);
